// extracted by mini-css-extract-plugin
export default {"loginDetails":"style_loginDetails__HUcyV","bgContent":"style_bgContent__IXpeU"};